// dynamic-field-multi-select.component.ts

import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { DynamicFieldsService } from '../dynamic-fields.service';
import * as _ from 'lodash';

@Component({
    selector: 'dynfield-multiselect',
    template: require('./dynamic-fields.multi-select.component.html'),
})
export class DynamicFieldMultiSelectComponent implements OnInit, OnChanges {
    @Input() version: number;
    @Input() field: any;
    @Input() fieldsOptions: any;
    @Input() fieldError: any;
    @Input() allowUpdate: boolean;
    @Input() isNewTrackerItem: boolean;
    @Input() acls: any;
    @Input() configurations: any;

    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

    label: string;
    error: any;
    isRequired: boolean;
    fieldOptions: any;

    constructor(private dynamicFieldsService: DynamicFieldsService) {}

    ngOnInit() {

        if (this.field.fieldName == 'sprint') {
            this.label = 'Sprint';
        } else {
            this.label = this.field.fieldName;
        }

        this.error = this.dynamicFieldsService.setError(this.fieldError, this.field);
        this.isRequired = this.dynamicFieldsService.isRequired(this);

        this.fieldOptions = this.dynamicFieldsService.getFieldOptions(
            this.fieldsOptions, this.field
        );

        if (this.fieldOptions.fieldType == 12 && this.isNewTrackerItem &&  
            this.fieldOptions.fieldElements.length > 0 && _.get(this.acls, 'permissionLevel', 0) == 1) {
            this.fieldOptions.fieldElements[0].defaultSelected = true;
        }

        let fieldData: any = null;

        if (_.isEmpty(this.configurations)) {
            this.configurations = {};
        }

        if (this.configurations.includeNone && 
            Array.isArray(_.get(this.fieldOptions, 'fieldElements', false)) &&
            !_.filter(this.fieldOptions.fieldElements, {id: 100}).length
        ) {
            this.fieldOptions.fieldElements = this.dynamicFieldsService.addNoneElement(this.fieldOptions);
        }

        if (this.configurations.multiSelect) {
            fieldData = this.getSelectedElements(
                _.get(this.field, 'fieldData', []),
                _.get(this.fieldOptions, 'fieldElements', [])
            );
        } else {
            fieldData = this.getSelectedElement(
                _.get(this.field, 'fieldData', []),
                _.get(this.fieldOptions, 'fieldElements', [])
            );
        }

        this.field.fieldData = fieldData;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.fieldError) {
            this.error = this.dynamicFieldsService.setError(
                changes.fieldError?.currentValue, this.field
            );
        }
    }

    /**
     * Resolves the stored value against the field's available elements.
     */
    private getSelectedElements(fieldData, elements) {
        const idList = _.map(fieldData, 'id');
        if (!this.configurations.includeNone) {
            _.remove(idList, id => id == 100);
        }

        const currentElements = idList
            .map(id => _.find(elements, { id: id }))
            .filter(item => !_.isEmpty(item));

        if (Array.isArray(currentElements) && currentElements?.length > 0) return currentElements;

        const noChangeOption = _.find(elements, { id: -1 });
        const defaultOption = _.find(elements, { defaultSelected: true });

        if (noChangeOption) return [noChangeOption];
        if (defaultOption && this.isNewTrackerItem) return [defaultOption];
        return [];
    }

    /**
     * Single-value counterpart of getSelectedElements(); the default applies to new items only,
     * for the same reason.
     */
    private getSelectedElement(fieldData, elements) {
        let id = _.get(fieldData, 'id', 0);

        if (id == 100 && !this.configurations.includeNone) {
            id = 0;
        }

        if (_.isEmpty(this.field.fieldData) && this.configurations.includeNone) {
            this.field.fieldData = this.dynamicFieldsService.getNoneElement();
        }

        const currentElement = _.find(elements, { id: id });

        if (_.isObject(currentElement) && !_.isEmpty(currentElement)) return currentElement;

        const noChangeOption = _.find(elements, { id: -1 });
        const defaultOption = _.find(elements, { defaultSelected: true });

        if (noChangeOption) return noChangeOption;
        if (defaultOption && this.isNewTrackerItem) return defaultOption;
        return {};
    }

    onSelectedChange() {
        this.onSelect.emit(this.field.fieldData);
    }
}
